import { render, staticRenderFns } from "./TagView.vue?vue&type=template&id=6acadce5&scoped=true&"
import script from "./TagView.vue?vue&type=script&lang=js&"
export * from "./TagView.vue?vue&type=script&lang=js&"
import style0 from "./TagView.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TagView.vue?vue&type=style&index=1&id=6acadce5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acadce5",
  null
  
)

export default component.exports